/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sinp_Col_UnitInputs */

const vi_sinp_col_unit = /** @type {(inputs: Sinp_Col_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ĐVT`)
};

/**

* @param {Sinp_Col_UnitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sinp_col_unit = /** @type {((inputs?: Sinp_Col_UnitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sinp_Col_UnitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sinp_col_unit(inputs)
});